<div [chart]="currentChart" style="max-height: 100px; max-width: 100px;"></div>
